module.exports = __webpack_public_path__ + "static/logistics-cust-booking@3x-a9ea5a499957266ee75a07b0772f49cd.png";